import { actionClient } from "@/api";

const state = {
  cateTree: [],
  regionTree: [],
};

// actions
const actions = {
  async getTree({ state, commit }) {
    const cateTree = await actionClient.get("category-tree");
    commit("setTree", cateTree);
    return state.cateTree;
  },
  async getRegion({ commit }) {
    const res = await actionClient.get("regions");
    commit("regionTree", res);
    return res;
  },
};

// mutations
const mutations = {
  setTree(state, cateTree) {
    state.cateTree = cateTree;
  },
  regionTree(state, res) {
    state.regionTree = res;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
